import React from "react";
import axios from 'axios';
import Select from 'react-select';

import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";
import { setPayTMAepsSection, storeAepsMerchantInfo } from "../../redux/aeps/aeps.action";
import { Link } from "react-router-dom";
import tokenErrorHandler from "../tokenErrorHandler";
import HeadeCommon from "../HeaderComponent/HeadeCommon";
import Menu from "../MenuComponent/Menu";
import FooterComponet from "../FooterComponent/FooterComponet";

const httpClient = axios.create();
class AEPSPayTM extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errMsg: '',
            loading: '',
            mobile: '',
            mobileErrorMsg: '',
            searchableBankList: [],
            searchableStateList: [],
            selectedBankName: '',
            selectedBankId: '',
            selectedStateName: '',
            stateVal: '',
            bankDetails: [],
            progress: '',
            name: '',
            nameErr: '',
            emptyList: [],
            city: '',
            cityErr: '',
            address: '',
            addressErr: '',
            pan: '',
            panErr: '',
            pincode: '',
            pinCodeErr: ''

        }
    }

    componentDidMount() {
        store.dispatch(setPayTMAepsSection(''));
        store.dispatch(storeAepsMerchantInfo(''));

        this.setState({
            mobileErrorMsg: '',
            amountErrrMsg: '',
            adhaarErrMsg: '',
            aePsActionErrMsg: '',
            bankErrMsg: '',
            aadhaar: '',
            kycErr: ''
        })
        this.getMerchantDetails();
        this.loadStateList();


    }
    componentWillUnmount() {
    }


    getMerchantDetails = () => {
        this.setState({
            errMsg: '',
            loading: 'started'
        })

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            // 'client-id': '123482',
            'role': this.props.clientRole
        }


        var getMerchantUrl = '/api/v1/paysprint/aeps/connector/get-merchant/';
        httpClient.get(getMerchantUrl +
            this.props.agentInfo.id,
            // '123482',
            { headers }
        ).then((response) => {
            // alert('get merchant info' + JSON.stringify(response.data));
            this.setState({
                loading: 'completed'
            })
            var onboardStatus = response.data.onboardStatus;


            if (onboardStatus == 'failed') {

                this.setState({
                    errMsg: 'Last onboard attempt message: ' + response.data.message
                })

                if (response.data.message.includes("Onboarding Rejected by bank") ||
                    response.data.message.includes("onboarding Rejected by bank")) {
                        store.dispatch(setPayTMAepsSection('kyc-failed'));
                } else {
                    store.dispatch(setPayTMAepsSection('kyc-failed'));
                }


                if (response.data.message.includes("Merchantcode is already available") ||
                    response.data.message.includes("merchantcode is already available") ||
                    response.data.message.includes("Merchant is already available") ||
                    response.data.message.includes("merchant is already available")
                ) {
                    setTimeout(() => {
                        this.callKycEnquiry(response.data.merchantInfo);
                    }, 400);
                }
            }
            if (onboardStatus == '') {
                store.dispatch(setPayTMAepsSection('kyc-incomplete'));
            }
            if (onboardStatus == 'pending') {
                store.dispatch(setPayTMAepsSection('kyc-pending'));
                //call Kyc Enquiry for final status
                if (response.data.merchantInfo != undefined &&
                    response.data.merchantInfo != null) {
                    setTimeout(() => {
                        this.callKycEnquiry(response.data.merchantInfo);
                    }, 400);

                }

            }
            if (onboardStatus == 'completed') {
                if (response.data.merchantInfo != undefined &&
                    response.data.merchantInfo != null) {
                    store.dispatch(storeAepsMerchantInfo(response.data.merchantInfo))
                    store.dispatch(setPayTMAepsSection('kyc-completed'));
                }

                setTimeout(() => {
                    history.push('/aeps-new');
                    history.go();
                }, 1000);

            }



        }
        ).catch(error => {

            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            } else {
                store.dispatch(setPayTMAepsSection(''));
                this.setState({
                    loading: 'completed',
                    errMsg: 'Error in getting merchant Info.',
                })


            }

        });
    }

    callKycEnquiry = (merchantInfo) => {
        this.setState({
            loading: 'started',
            errMsg: ''
        })

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }


        var req = {
            merchantcode: this.props.agentInfo.id,
            mobile: merchantInfo.merchantmobilenumber,
            pipe: 'bank5'
        }
        var enquiryUrl = '/api/v1/paysprint/aeps/connector/onboard-status';
        httpClient.post(enquiryUrl, req,
            { headers }
        ).then((response) => {
            console.log('get merchant info' + JSON.stringify(response.data));
            this.setState({
                loading: 'completed'
            })
            var onboardStatus = response.data.onBoardSatatus;

            if (response.data.merchantInfo != undefined &&
                response.data.merchantInfo != null) {
                store.dispatch(storeAepsMerchantInfo(response.data.merchantInfo))

            }
            if (onboardStatus == 'failed') {

                if (response.data.message.includes("Onboarding Rejected by bank") ||
                    response.data.message.includes("onboarding Rejected by bank")) {
                    store.dispatch(setPayTMAepsSection('kyc-failed'));
                } else {
                    store.dispatch(setPayTMAepsSection('kyc-failed'));
                }

                this.setState({
                    errMsg: 'Last onboard attempt message: ' + response.data.message
                })
            }
            if (onboardStatus == '') {
                store.dispatch(setPayTMAepsSection('kyc-incomplete'));
            }
            if (onboardStatus == 'pending') {
                store.dispatch(setPayTMAepsSection('kyc-pending'));
            }
            if (onboardStatus == 'completed') {
                store.dispatch(setPayTMAepsSection('kyc-completed'));
                setTimeout(() => {
                    history.push('/aeps-new');
                    history.go();
                }, 300);

            }


        }
        ).catch(error => {
            this.setState({
                loading: 'completed'
            })
            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            } else {

                store.dispatch(setPayTMAepsSection('kyc-pending'));
            }

        });

    }


    proceedToKyc = (event) => {
        event.preventDefault();
        this.setState({
            errMsg: ''
        })
        var validate = this.validateBeforeKyc();
        if (validate == true) {
            this.doKyc();
        }
    }

    validateBeforeKyc = () => {
        this.setState({
            nameErr: '',
            mobileErrorMsg: '',
            stateErrMsg: '',
            iinErr: '',
            cityErr: '',
            addressErr: '',
            panErr: '',
            pinCodeErr: '',
            errMsg: ''
        })

        var nameValidation = false;
        var mobileValidation = false;
        var stateValidation = false;
        var iinValidation = false;
        var cityvalidation = false;
        var addressvalidation = false;
        var panvalidation = false;
        var pincodevalidation = false;
        var panCardRegex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;


        if (this.state.name == '') {
            this.setState({
                nameErr: 'Please enter name'
            })
        } else {
            nameValidation = true;
        }

        if (this.state.mobile == '' || this.state.mobile.length != 10) {
            this.setState({
                mobileErrorMsg: 'Please enter valid mobile No'
            })
        } else {
            mobileValidation = true;
        }
        if (this.state.selectedStateName == '' || this.state.selectedStateName == 'Select State') {
            this.setState({
                stateErrMsg: 'Please select a state'
            })
        } else {
            stateValidation = true;
        }

        if (this.state.city == '') {
            this.setState({
                cityErr: 'Please enter city'
            })
        } else {
            cityvalidation = true;
        }
        if (this.state.address == '') {
            this.setState({
                addressErr: 'Please enter address'
            })
        } else {
            addressvalidation = true;
        }
        if (this.state.address == '') {
            this.setState({
                addressErr: 'Please enter address'
            })
        } else {
            addressvalidation = true;
        }


        if (panCardRegex.test(this.state.pan) && this.state.pan != '') {
            panvalidation = true;
        } else {
            this.setState({
                panErr: 'Please enter correct PAN no.'
            })
        }
        if (this.state.pincode == '' || this.state.pincode.length != 6) {
            this.setState({
                pincodeErr: 'Please select a bank'
            })
        } else {
            pincodevalidation = true;
        }


        // alert("nameValidation:" + nameValidation + "mobileValidation:" + mobileValidation +
        //     "stateVlidation:" + stateValidation + "cityvalidation:" + cityvalidation +
        //     "addressvalidation:" + addressvalidation + "panvalidation:" + cityvalidation +
        //     "pincodevalidation:" + pincodevalidation);
        //etc

        if (nameValidation == true
            && mobileValidation == true
            && stateValidation == true
            && cityvalidation == true
            && addressvalidation == true
            && panvalidation == true
            && pincodevalidation == true

        ) {
            return true
        } else {
            return false
        }
    }
    proceedToKyc = (event) => {
        event.preventDefault();
        this.setState({
            errMsg: ''
        })
        var validate = this.validateBeforeKyc();
        // alert(validate)
        if (validate == true) {
            this.doKyc();
        }
    }

    doKyc = () => {

        this.setState({
            loading: 'start'
        })
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            // 'client-id': '123482',
            'role': this.props.clientRole
        }


        var coordinates = this.props.deviceInfo.location.coordinates;
        var lat = coordinates[0];
        var long = coordinates[1];


        var req = {
            merchantmobilenumber: this.state.mobile,
            submerchantid: this.props.agentInfo.id,
            // submerchantid: '123482',
            statecode: this.state.stateVal,
            city: this.state.city,
            merchant_name: this.state.name,
            address: this.state.address,
            pannumber: this.state.pan,
            pincode: this.state.pincode,
            latitude: lat,
            longitude: long
        }

        // alert(JSON.stringify(req))
        var kycUrl = '/api/v1/paysprint/aeps/connector/merchant-onboard';
        httpClient.post(kycUrl, req,
            { headers }
        ).then((response) => {
            this.setState({
                loading: 'completed'
            })
            console.log('kyc response' + JSON.stringify(response.data));
            // alert(JSON.stringify(response.data))
            // {"status":true,"response_code":1,"message":"Merchant data accepted.","errorCode":"0","onBoardSatatus":"pending"}
            if (response.data.onBoardSatatus == 'pending') {
                store.dispatch(setPayTMAepsSection('kyc-pending'));
            }
            if (response.data.onBoardSatatus == 'completed') {
                store.dispatch(setPayTMAepsSection('kyc-completed'));
            }
            if (response.data.onBoardSatatus == 'failed') {
                store.dispatch(setPayTMAepsSection('kyc-failed'));
                this.setState({
                    errMsg: 'Onboard failed-' + response.data.message
                })
                if (response.data.message.includes("Merchantcode is already available") ||
                    response.data.message.includes("merchantcode is already available") ||
                    response.data.message.includes("Merchant is already available") ||
                    response.data.message.includes("merchant is already available")) {

                    var merchantInfo = {
                        merchantmobilenumber: this.state.mobile
                    }

                    setTimeout(() => {
                        this.callKycEnquiry(merchantInfo);
                    }, 400);
                }
            }

        }
        ).catch(error => {
            this.setState({
                loading: 'completed'
            })

            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            } else {
                store.dispatch(setPayTMAepsSection('kyc-failed'));
                this.setState({
                    errMsg: 'Onboard failed-' + error.message
                })
            }

        });
    }

    enterCity = (event) => {
        event.preventDefault();
        this.setState({
            city: event.target.value
        })
    }
    enterAddress = (event) => {
        event.preventDefault();
        this.setState({
            address: event.target.value
        })
    }

    enterPAN = (event) => {
        event.preventDefault();
        this.setState({
            pan: event.target.value
        })
    }

    enterPinCode = (event) => {
        event.preventDefault();
        this.setState({
            pincode: event.target.value
        })
    }


    loadStateList() {

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            // 'client-id': '123482',
            'role': this.props.clientRole
        }

        var searchableStateList = [];
        var stateListUrl = '/api/v1/paysprint/aeps/connector/state-list';
        httpClient.get(stateListUrl,
            { headers }
        ).then((response) => {
            console.log('state list' + JSON.stringify(response.data.statecodelist.data));
            if (response.data.statecodelist.data.length > 0) {

                response.data.statecodelist.data.map(state => {
                    var stateVal = {
                        value: '',
                        label: ''
                    }
                    stateVal.value = state.statecode;
                    stateVal.label = state.statename;

                    searchableStateList.push(stateVal);
                })
                this.setState({
                    searchableStateList: searchableStateList
                })
            }
        }).catch(error => {

            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            }

        });
    }



    stateChange = (selected) => {

        this.setState({
            stateErrMsg: '',
            selectedStateName: selected.label,
            stateVal: selected.value
        })
    }
    enterMobile = (e) => {
        e.preventDefault();
        this.setState({
            mobileErrorMsg: '',
            mobile: e.target.value
        })
    }
    enterFullName = (e) => {
        e.preventDefault();
        this.setState({
            nameErr: '',
            name: e.target.value
        })
    }




    render() {

        return (
            <div>
                <HeadeCommon />
                <Menu />
                <div class='col-12'>

                    <div class="card-b" id="rightdiv">
                        <div class="head">

                            <h3>AePS</h3>

                        </div>



                        {this.state.errMsg != '' &&
                            <div class='valid-error'>
                                {this.state.errMsg}
                            </div>
                        }
                        {this.state.loading == 'started' &&
                            <div class='valid-success'>
                                Retrieving Merchant details, please wait...
                            </div>
                        }
                        {this.state.loading == 'completed' &&
                            this.props.payTmKycSection == 'kyc-completed' &&
                            <div class='valid-success'>
                                Merchant registration completed, Going to AePS page...
                            </div>
                        }
                        {this.state.loading == 'completed' &&
                            this.props.payTmKycSection == 'kyc-failed' &&
                            <div class='valid-error'>
                                Merchant registration failed, Please register again with below form!
                            </div>
                        }
                        {this.state.loading == 'completed' &&
                            this.props.payTmKycSection == 'kyc-pending' &&
                            <div class='valid-success'>
                                Merchant registration in progress, Status will be updated later.
                            </div>
                        }
                        {this.state.loading == 'completed' &&
                            this.props.payTmKycSection == 'kyc-incomplete' &&
                            <div class='valid-success'>
                                Merchant registration is needed,  Please register with below form!.
                            </div>
                        }


                        {this.state.loading == 'completed' &&
                            (this.props.payTmKycSection == 'kyc-incomplete' ||
                                this.props.payTmKycSection == 'kyc-failed') &&
                            <div class="reviewbox">
                                <form onSubmit={this.proceedToKyc}>
                                    <div class="row">
                                        <div class="col-12 col-sm-6">
                                            <div class="form-floating mb-3 mt-3">
                                                <input type="text" id="name" class="form-control"
                                                    placeholder="Enter Merchant Name" name="name"
                                                    onChange={this.enterFullName}
                                                    required
                                                />
                                                <label for="name">Merchant Name</label>
                                            </div>
                                            {this.state.nameErr != '' &&
                                                <div class='valid-error'>
                                                    {this.state.nameErr}
                                                </div>
                                            }
                                        </div>


                                        <div class="col-12 col-sm-6">
                                            <div class="form-floating mb-3 mt-3">
                                                <input type="number" id="mdn" class="form-control"
                                                    placeholder="Enter Merchant mobile" name="mobile"
                                                    value={this.state.mobile}
                                                    onChange={this.enterMobile}
                                                    onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
                                                    required />
                                                <label for="mdn">Merchant Mobile Number</label>
                                            </div>
                                            {this.state.mobileErrorMsg != '' &&
                                                <div class='valid-error'>
                                                    {this.state.mobileErrorMsg}
                                                </div>
                                            }

                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <div class="form-floating mb-3 mt-3">
                                                <input type="text" id="city" class="form-control"
                                                    placeholder="Enter Merchant City" name="city"
                                                    onChange={this.enterCity}
                                                    required
                                                />
                                                <label for="name">Merchant city</label>
                                            </div>
                                            {this.state.nameErr != '' &&
                                                <div class='valid-error'>
                                                    {this.state.cityErr}
                                                </div>
                                            }
                                        </div>

                                        <div class="col-12 col-sm-6">
                                            <div class="form-floating mb-3 mt-3">
                                                <input type="text" id="address" class="form-control"
                                                    placeholder="Enter Merchant Address" name="address"
                                                    onChange={this.enterAddress}
                                                    required
                                                />
                                                <label for="name">Merchant Address</label>
                                            </div>
                                            {this.state.nameErr != '' &&
                                                <div class='valid-error'>
                                                    {this.state.addressErr}
                                                </div>
                                            }
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <div class="form-floating mb-3 mt-3">
                                                <Select class="mdb-select"
                                                    //  options={this.state.emptyList}
                                                    options={this.state.searchableStateList}
                                                    SelectContainer={true}
                                                    defaultValue={{
                                                        label: this.state.selectedStateName == '' ? 'Select State' : this.state.selectedStateName,
                                                        value: this.state.selectedStateName == '' ? 'Select State' : this.state.selectedStateName
                                                    }}
                                                    onChange={this.stateChange}
                                                    placeholder={this.state.selectedStateName}
                                                    required
                                                />
                                            </div>

                                            {this.state.stateErrMsg != '' &&
                                                <div class='valid-error'>
                                                    {this.state.stateErrMsg}
                                                </div>
                                            }
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <div class="form-floating mb-3 mt-3">
                                                <input type="text" id="pannumber" class="form-control"
                                                    placeholder="Enter Merchant Pan" name="pannumber"
                                                    onChange={this.enterPAN}
                                                    required
                                                />
                                                <label for="name">Merchant PAN</label>
                                            </div>
                                            {this.state.panErr != '' &&
                                                <div class='valid-error'>
                                                    {this.state.panErr}
                                                </div>
                                            }
                                        </div>

                                        <div class="col-12 col-sm-6">
                                            <div class="form-floating mb-3 mt-3">
                                                <input type="number" id="pincode" class="form-control"
                                                    placeholder="Enter Merchant Pincode" name="pincode"

                                                    onChange={this.enterPinCode}
                                                    onInput={(e) => e.target.value = e.target.value.slice(0, 6)}
                                                    required />
                                                <label for="mdn">Merchant Pincode</label>
                                            </div>
                                            {this.state.pinCodeErr != '' &&
                                                <div class='valid-error'>
                                                    {this.state.pinCodeErr}
                                                </div>
                                            }

                                        </div>
                                        <div class="w-100"></div>

                                    </div>
                                    <div class="col-12 col-sm-6">

                                        <button type="submit" class="btn btn-primary"
                                            id="proceedKyc"
                                        // disabled={this.state.progress == 'loading' && true}
                                        >Proceed</button>
                                        {this.state.kycErr != '' &&
                                            <div class='valid-error'>
                                                {this.state.kycErr}
                                            </div>
                                        }

                                    </div>
                                </form>
                            </div>
                        }





                    </div>
                    {/* } */}
                </div>
                <FooterComponet />
            </div>
        );
    }
}


const mapStateToProps = ({ errorMessageReduce: { errorMessage, loginErrorMessage },
    miscReduce: { phone, agentInfo, token, deviceInfo, clientRole, callBackUrl },
    aepsReduce: { payTmKycSection }
}
) => ({
    errorMessage, loginErrorMessage,
    phone, agentInfo, token, deviceInfo, clientRole, callBackUrl,
    payTmKycSection
});




export default connect(mapStateToProps, null)(AEPSPayTM);
